import type { EventHint } from '@sentry/core';
import type { ErrorContext } from './error-reporter';

/** What both apps' Sentry reporters pass with an error: whether it was handled, and its tags. */
export function sentryHint({ tags, handled = true }: ErrorContext = {}): EventHint {
  return {
    mechanism: { type: 'generic', handled },
    ...(tags ? { captureContext: { tags: { ...tags } } } : {}),
  };
}
